/*
  ErrorBoundary.jsx
*/

// Npm.
import React from 'react';
import { css } from '@emotion/css';

/**
 * Wraps a portion of the app with error-catching code.
 */
export default class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };

    this.rootClass = css({
      padding: '8px',
      textAlign: 'center',
      overflow: 'hidden',
      '&.inline': {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '&.fullScreen': {
        position: 'fixed',
        top: '50%',
        left: 0,
        right: 0,
        maxHeight: '100%',
        transform: 'translateY(-50%)',
      },
      '& h4': {
        marginTop: 0,
      },
    });

    this.handleClickRetry = this.handleClickRetry.bind(this);  // Safari requires this syntax.
    this._lastRetry = null;
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  handleClickRetry(event) {
    event.preventDefault();

    // Throttle the retry so people don't spam the retry button
    // and caus the error to happen over and over.

    const now = Date.now();
    if (this._lastRetry == null || this._lastRetry < now - 500) {
      this._lastRetry = now;
      
      if (this.props.onRetry) {
        this.props.onRetry();
      }
      
      this.setState({ error: null });

    }
  }

  componentDidCatch(error, errorInfo) {

    if (this.props.onError) {
      this.props.onError(error);
    }

    // Optionally log error.

  }

  render() {

    const error = this.state.error;

    if (error) {
      return (
        <div className={`${this.rootClass} fadeIn ${this.props.fullScreen ? 'fullScreen' : 'inline'}`}>
          <div>
            <h4 className="gutterBottom">Something went wrong!</h4>
            <p className="paragraph">An error has occurred while loading the content.</p>
            <p className="body2 paragraph">"{ error.message }"</p>
            <div>
              <button type="button" onClick={this.handleClickRetry}>
                Click to Reload
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children; 

  }

}
